"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[466,3023],{

/***/ 53023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EVENTS": function() { return /* binding */ EVENTS; },
/* harmony export */   "sendPosthogData": function() { return /* binding */ sendPosthogData; },
/* harmony export */   "sendPosthogUserInfo": function() { return /* binding */ sendPosthogUserInfo; },
/* harmony export */   "setBasicProperties": function() { return /* binding */ setBasicProperties; },
/* harmony export */   "setPosthogUserId": function() { return /* binding */ setPosthogUserId; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src372417191_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src372417191_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src372417191_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99893);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var setPosthogUserId = function(userId) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].identify */ .Z.identify(userId);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var setBasicProperties = function(properties) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return;
    properties = _objectSpread({}, properties, {
        store: window.location.hostname,
        storeUrl: window.location.hostname,
        path: window.location.pathname,
        websiteVersion: "nextjs"
    });
    posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].register */ .Z.register(properties);
};
var sendPosthogUserInfo = function(userInfo) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].people.set */ .Z.people.set(userInfo);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var sendPosthogData = function() {
    var _ref = _asyncToGenerator(_codebuild_output_src372417191_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventType) {
        var eventProperties, obj, body, _args = arguments;
        return _codebuild_output_src372417191_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventProperties = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    _ctx.prev = 1;
                    obj = JSON.parse(JSON.stringify(eventProperties));
                    if (!(eventType === EVENTS.pageView.checkout && eventProperties.checkoutVersion !== "v3" && eventProperties.checkoutVersion !== "v2")) {
                        _ctx.next = 7;
                        break;
                    }
                    body = JSON.stringify({
                        viewer: {},
                        message: eventProperties,
                        stack: "Test posthog Event",
                        path: "ab/c"
                    });
                    _ctx.next = 7;
                    return fetch("https://api.getjusto.com/error-stack", {
                        method: "POST",
                        body: body
                    });
                case 7:
                    posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].capture */ .Z.capture(eventType, _objectSpread({}, obj));
                    _ctx.next = 14;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error({
                        e: _ctx.t0
                    });
                    _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exception */ .Z.exception("Posthog not loaded");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function sendPosthogData(eventType) {
        return _ref.apply(this, arguments);
    };
}();
var EVENTS = Object.freeze({
    clicked: {
        productChangeAmount: "clicked-productChangeAmount",
        addressComponentOrder: "clicked-addressComponentOrder",
        checkoutLogin: "clicked-checkoutLogin",
        upselling: "clicked-upselling",
        login: "clicked-login",
        cartRemoveProduct: "clicked-cartRemoveProduct",
        cartContinueToCheckout: "clicked-cartContinueToCheckout",
        cart: "clicked-cart",
        search: "clicked-search",
        product: "clicked-product",
        productAddToCart: "clicked-productAddToCart",
        help: "clicked-help",
        cancelOrder: "clicked-cancel-order",
        changePreferredStore: "clicked-change-preferred-store",
        omitLogin: "clicked-omit-login",
        editProduct: "clicked-edit-product",
        saveEditProduct: "clicked-save-edit-product",
        giftCheckout: "clicked-gift-checkout",
        useLocation: "clicked-use-location",
        addressSubmitButton: "clicked-address-submit-button",
        addressClear: "clicked-address-clear-button"
    },
    selected: {
        addressOption: "selected-address-option"
    },
    results: {
        addressSuggestions: "results-address-suggestions",
        placeIdIsCovered: "results-place-id-is-covered"
    },
    error: {
        locationAccessDenied: "error-location-access-denied",
        locationUnavailable: "error-location-unavailable"
    },
    blocked: {
        addressSuggestionsEmpty: "blocked-address-suggestions-empty",
        placeIdNotCovered: "blocked-place-id-not-covered",
        storeClosed: "blocked-store-closed"
    },
    dragged: {
        addressPin: "dragged-address-pin"
    },
    product: {
        setQuantityTo0: "update-quantity-0-product"
    },
    pageView: {
        checkout: "pageView-checkout",
        order: "pageView-order",
        home: "pageView-home",
        tracking: "pageView-tracking",
        publication: "pageView-publication"
    },
    coupon: {
        apply: "coupon-apply",
        failed: "coupon-failed"
    },
    address: {
        failed: "address-failed",
        accept: "address-accept"
    },
    pay: {
        passValidations: "pay-passValidations",
        failed: "pay-failed",
        successful: "pay-successful",
        successfulTest: "pay-successful-test"
    },
    login: "login",
    startSession: "start-session",
    auth: {
        startsAuthModal: "auth-modal-starts",
        authModalEndsSuccess: "auth-modal-ends-success",
        authModalEndsNoAuth: "auth-modal-ends-no-auth"
    }
});


/***/ }),

/***/ 69598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WithPosthog": function() { return /* binding */ WithPosthog; },
  "default": function() { return /* binding */ usePosthog; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
;// CONCATENATED MODULE: ./src/helpers/posthog/config.ts
var posthogProd = "phc_6iSnqhLXoUrIssc5cfgjf9YrF5voKG18RK9Sk9bKuSM";
var posthogDev = "phc_JO6OBNTSVv4G3rLGXMysmHxsEAOTaHXjFExlP5hMsgs";
var urlPosthogProd = "https://posthog.tools.justo.ninja";
var urlPosthogDev = "https://posthog.sandbox.justo.ninja";

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/posthog-js/dist/es.js
var es = __webpack_require__(99893);
;// CONCATENATED MODULE: ./src/helpers/posthog/usePosthog.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function usePosthog(param) {
    var pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // Init PostHog
        es/* default.init */.Z.init((0,getEnv/* default */.Z)() === "prod" ? posthogProd : posthogDev, {
            api_host: (0,getEnv/* default */.Z)() === "prod" ? urlPosthogProd : urlPosthogDev
        });
        // if need to test new events please remove this if
        if ((0,getEnv/* default */.Z)() === "local") {
            es/* default.opt_out_capturing */.Z.opt_out_capturing();
        } else {
            es/* default.clear_opt_in_out_capturing */.Z.clear_opt_in_out_capturing();
        }
        (0,posthog.setBasicProperties)(_objectSpread({}, pageProps.website));
        // Track page views
        var handleRouteChange = function() {
            return es/* default.capture */.Z.capture("$pageview");
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, []);
    return null;
};
var WithPosthog = function(param) {
    var pageProps = param.pageProps, children = param.children;
    usePosthog({
        pageProps: pageProps
    });
    return children;
};


/***/ })

}]);